import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_static/terms')({
	component: TermsPage,
});

function TermsPage() {
	const { t } = useTranslation();
	return <h1>{t('staticPages.terms.title')}</h1>;
}
